import { ResponseBase } from '../response-base.model';
import { GrupoQuizz } from './grupo-quizz';
export class AltaGrupoResponse extends ResponseBase {
    grupo: GrupoQuizz;
}
